module.exports = __webpack_public_path__ + "static/media/Danger_2.4d13315a.svg";